import { addIntersectionItem } from '../util'

// const startDuration = 12000
// const startDistance = 750

export default function AppScreens() {
    let els = document.querySelectorAll('.js-app-screens')

    els.forEach((el) => {
        addIntersectionItem(el, animAppScreens)
    })
}

function animAppScreens({ el }, entry) {
    if (!entry.isIntersecting || el.dataset.active) {
        return
    }

    el.dataset.active = true
    let distance = el.scrollWidth - window.innerWidth + 30
    el.style.setProperty('--distance', distance + 'px')
    // let duration = (distance / startDistance) * startDuration
    // el.style.transform = `translateX(-${distance}px)`
    // el.style.setProperty('--duration', `${duration}ms`)
}
